import React, { useState } from "react";
import { Link } from "react-router-dom";
import { staticLogoForName } from "@/lib/guaranteedOutlets";

function formatPrice(price) {
  if (price == null) return null;
  return "$" + Math.round(price).toLocaleString("en-US");
}

function PlacementLogo({ src, name, onError }) {
  return (
    <div className="h-14 flex items-center justify-center mb-4">
      <img
        src={src}
        alt={name}
        className="max-h-10 max-w-[140px] w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
        onError={onError}
      />
    </div>
  );
}

function TextLogo({ name }) {
  return (
    <div className="h-14 flex items-center justify-center mb-4">
      <span className="font-heading text-lg font-bold text-[#6c6c74] group-hover:text-[#1c1c20] transition-colors duration-300">
        {name}
      </span>
    </div>
  );
}

export default function PlacementCard({ record, display, name: configName, href }) {
  const [logoError, setLogoError] = useState(false);

  const name = display || (record && record.name) || configName || "";
  const logo = !logoError
    ? staticLogoForName(name) || (record && record.brand_logo_url) || null
    : null;
  const da = record && record.domain_authority != null ? record.domain_authority : null;
  const linkType = record && record.link_type ? record.link_type : null;
  const price = record ? (record.discount_price_usd != null ? record.discount_price_usd : record.price_usd) : null;
  const tier1 = !!(record && record.is_tier_1);
  const priceLabel = formatPrice(price);

  const inner = (
    <>
      {tier1 && (
        <span className="absolute top-3 right-3 font-mono text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded-sm bg-[rgba(124,58,237,0.1)] text-[#7c3aed] border border-[rgba(124,58,237,0.2)]">
          Tier 1 Publication
        </span>
      )}
      {logo ? (
        <PlacementLogo src={logo} name={name} onError={() => setLogoError(true)} />
      ) : (
        <TextLogo name={name} />
      )}
      <div className="mt-auto pt-3">
        {priceLabel && (
          <div className="font-heading text-lg font-bold text-[#1c1c20]">{priceLabel}</div>
        )}
        {(da != null || linkType) && (
          <div className="flex items-center justify-between text-xs text-[#6c6c74] mt-2 pt-2 border-t border-[rgba(28,28,32,0.06)]">
            {da != null && <span className="font-medium">DA {da}</span>}
            {linkType && <span className="capitalize">{linkType}</span>}
          </div>
        )}
      </div>
    </>
  );

  const className =
    "group relative bg-[rgba(255,255,255,0.58)] backdrop-blur-xl border border-[rgba(255,255,255,0.85)] rounded-2xl p-5 lg:p-6 flex flex-col hover:-translate-y-0.5 transition-all duration-200";

  if (href) {
    return (
      <Link to={href} className={className}>
        {inner}
      </Link>
    );
  }
  return <div className={className}>{inner}</div>;
}